import {lazyWithRetry} from '../lazyWithRetry/lazyWithRetry';

export const LazyNotificationsList = lazyWithRetry(() =>
  import('./notificationsList')
);

